// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__26jW_","choiceBoxes":"toolbarselects_choiceBoxes__2nEm2","simpleField":"toolbarselects_simpleField__1oOQh"};